import { CbhFeatureFlag } from "@src/appV2/FeatureFlags";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useStarredProfessionalConfiguration() {
  return useCbhFlag(CbhFeatureFlag.STARRED_PROFESSIONAL_CONFIGURATION, {
    defaultValue: {
      enabled: false,
    },
  });
}
